
import { z } from "zod";

export const EscalationStageValues = ["NOT_CONTACTED", "PENDING_CONTACT", "PENDING_RESOLUTION", "RESOLVED_PENDING_COMPLETION", "COMPLETION", "DISMISSED"] as const;
export const EscalationStageSchema = /* @__PURE__ */ z.enum(EscalationStageValues);
export const EscalationStage: (typeof EscalationStageSchema)["enum"] = { "NOT_CONTACTED": "NOT_CONTACTED", "PENDING_CONTACT": "PENDING_CONTACT", "PENDING_RESOLUTION": "PENDING_RESOLUTION", "RESOLVED_PENDING_COMPLETION": "RESOLVED_PENDING_COMPLETION", "COMPLETION": "COMPLETION", "DISMISSED": "DISMISSED" };
export type EscalationStage = (typeof EscalationStageValues)[number];
